module.exports = __webpack_public_path__ + "static/media/DMFIcon_MiniSet.3af851b6.png";